import styled from 'styled-components'

export const HorizontalTimelineContainer = styled.div`
     display: flex;
     padding-top: 100px;
     padding-bottom: 250px;

     @media (max-width: 550px) {
        /* Phones */
        padding-top: 30px;
        padding-bottom: 150px;
        font-size: 0.8em;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        padding-top: 30px;
        padding-bottom: 150px;
        font-size: 0.8em;
      }

`

export const TimelineItem = styled.div`
     flex: 1;
     text-align: center;
     position: relative;

     img{
      width: 600px;
     }

     &::before{
      bottom: 1.25em;
      content: "";
      display: block;
      height: 3px;
      background-color: rgba(234, 11, 42, 1);
      position: absolute;
      left: 0;
      width: 50%;

      @media (max-width: 550px) {
        /* Phones */
        height: 2px;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        height: 2px;
      }
     }

     &::after{
      background-color: rgba(234, 11, 42, 1);
      bottom: 1.25em;
      content: "";
      display: block;
      height: 3px;
      position: absolute;
      right: 0;
      width: 50%;

      @media (max-width: 550px) {
        /* Phones */
        height: 2px;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        height: 2px;
      }
     }
`

export const Circle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  
  h4{
    color: rgba(234, 11, 42, 1);
     font-weight: bold;
     margin-top: 10px;
  }

  p{
     margin-bottom: 0;
     padding: 0 5px;
     color: rgba(40, 44, 52, 1);
  }

  img{
    width: 120px;
    margin-top: 10px;
  }
`

export const CircleImg = styled.div`
  img{
    width: 20px;
    margin-top: ${props => props.marginTop};
    margin-bottom: ${props => props.marginBottom};

    @media (max-width: 550px) {
      /* Phones */
      width: 10px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 10px;
    }
  }
`

export const CircleCenter = styled.div`
     height: 30px;
     width: 30px;
     border: 3px solid rgba(234, 11, 42, 1);
     display: flex;
     position: relative;
     border-radius: 100%;
     top: -43px;
     margin: 3px auto;
     display: flex;
     align-items: center;
     justify-content: center;

     @media (max-width: 550px) {
      /* Phones */
      width: 15px;
      height: 15px;
      top: -30px;
      border: 2px solid rgba(234, 11, 42, 1);
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 15px;
      height: 15px;
      top: -30px;
      border: 2px solid rgba(234, 11, 42, 1);
    }

     span{
      margin: 0;
      height: 20px;
      width: 20px;
      background-color: rgba(234, 11, 42, 1);
      border-radius: 100%;
      position: absolute;
      z-index: 1;

    @media (max-width: 550px) {
      /* Phones */
      width: 8px;
      height: 8px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 8px;
      height: 8px;
    }

     }
`